// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { TransitionGroup } from 'react-transition-group'
import LoadingBar from 'react-redux-loading-bar'
import { Switch, Route } from 'react-router-dom'

// Internal Dependencies:
import PageEvents from 'containers/PageEvents'
import HeaderPrimary from 'components/HeaderPrimary/HeaderPrimary'
import HeaderMobilePrimary from 'components/HeaderPrimary/HeaderMobilePrimary'
import Menu from 'components/menu/menu'
import PageHeader from 'components/PageHeader/PageHeader'
import Footer from 'components/Footer/Footer'
import ErrorBoundary from 'components/ErrorBoundary/ErrorBoundary'
import SaveState from 'components/SaveState/SaveState'

const siteImage = siteData.site_featured_image_url
const siteImageSrcset = siteData.site_featured_image_srcset

class SiteLayout extends React.Component {
	render() {
		const { isMobile, siteId, hasSidebar, page, location, match } = this.props
		let className = '/' == location.pathname ? 'site-wrap is-home' : 'site-wrap'
		let showPageHeader = true

		if ( '/checkout' == location.pathname ) {
			showPageHeader = false
		}

		return (
			<div className={ className }>
				<PageEvents />
				<SaveState />

				<div className="site">
					<HeaderMobilePrimary />

					<div className="main-wrap">
						<LoadingBar className="header-loading-bar" updateTime={ 100 } maxProgress={ 90 } progressIncrease={ 10 } />

						<HeaderPrimary match={ match } />

						<section className="main">
							{ '/' != location.pathname && showPageHeader &&
								<PageHeader key="page-header" pathname={ location.pathname } />
							}

							{ this.props.children }
						</section>
					</div>
				</div>

				<Footer />

				<div className="chicken-bg-bottom">
					<img src={ `${siteData.images_url}bg/chook-1-e4e4e2.jpg` } alt="" />
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		isMobile: state.site.isMobile,
		hasSidebar: state.site.hasSidebar,
		page: state.page.selected
	}
}

export default connect( mapStateToProps )( SiteLayout )



// WEBPACK FOOTER //
// ./views/layouts/SiteLayout.jsx